import get from 'lodash.get';

const getColorPaletteVersion = (state) =>
  get(state, 'ws.template.meta.customization.colorPaletteVersion', null);

export default getColorPaletteVersion;
